const t = "{{currentTime}} จาก {{duration}}", A = "ผลการค้นหา {{current}} จาก {{total}}", n = "ไม่พบผลลัพธ์", o = "พบ {{count}} ผลลัพธ์", E = "พบ {{count}} ผลลัพธ์", c = 'กำลังเปิดเล่นจาก $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) และ $t(SECONDS, { "count": {{seconds}} })', T = 'กำลังเปิดเล่นจาก $t(MINUTES, { "count": {{minutes}} }) และ $t(SECONDS, { "count": {{seconds}} })', _ = 'กำลังเปิดเล่นจาก $t(SECONDS, { "count": {{seconds}} })', s = "มีข้อผิดพลาดในการบันทึกการเปลี่ยนแปลงไปยังบทอ่าน", S = "บรรทัดบทอ่านที่ {{time}} เนื้อหาคือ: {{text}}.", N = 'ส่วนจัดเก็บบรรทัดบทอ่าน มี $t(TRANSCRIPT_LINES, { "count": {{count}} }) ในส่วนการจัดเก็บนี้ สืบค้นภายในส่วนจัดเก็บนี้โดยใช้ปุ่มลูกศรลง', R = "กำลังบันทึกการเปลี่ยนแปลง...", O = "บันทึกการเปลี่ยนแปลงไปยังบทอ่านแล้ว", I = "ปุ่มอัพเดตคำบรรยายพร้อมใช้งานแล้วตอนนี้", C = "การดำเนินการ", P = "เพิ่มหมายเหตุกำกับที่ {{time}}", U = "เพิ่มคำถามเวลา {{time}}", L = "หมายเหตุกำกับ", D = "อัตโนมัติ", e = "อัตโนมัติ ({{quality}})", M = "ย้อนกลับ", u = "คำบรรยาย", G = "ภาษาคำบรรยาย", Y = "จัดการคำบรรยาย", H = "ลบ {{language}}", r = "ขนาดแบบอักษร", V = "ภาษาคำบรรยาย: {{language}}", B = "{{language}} (อัตโนมัติ)", i = "ล้างการค้นหา", a = "ปิด", K = "ความเห็น", m = "ดำเนินการต่อ", F = "ลดความเร็วในการเปิดเล่น", d = "ลดระดับเสียงลง {{percent}}%", l = "ลูกศรลง", h = "ปิดเครื่องมือแก้ไขบทอ่าน", W = "อัพเดตคำบรรยาย", $ = "ข้อผิดพลาด!", g = "กำลังบันทึก...", Q = "บันทึกแล้ว!", J = "แก้ไขบทอ่าน", p = "ข้อความปล่อยว่างไม่ได้", x = "เต็มหน้าจอ", Z = "{{count}} ชั่วโมง", X = "{{count}} ชั่วโมง", f = "เพิ่มความเร็วในการเปิดเล่น", q = "เพิ่มระดับเสียง {{percent}}%", v = "กลับสี", y = "ข้ามไปที่หน่วยเปอร์เซ็นต์ (1-10%, 2-20% ฯลฯ)", b = "ข้ามไปจุดเริ่มต้น", j = "การดำเนินการสำหรับ {{title}}", k = "ชอร์ตคัทแป้นพิมพ์", w = "ภาษา", z = "ลูกศรซ้าย", tt = "เมนูหลัก", At = "{{count}} นาที", nt = "{{count}} นาที", ot = "เสียงเงียบ", Et = "ปิดเสียงแล้ว", ct = "ภาษาคำบรรยายถัดไป", Tt = "ผลการค้นหาถัดไป", _t = "ปิด", st = "ด้านบน", St = "เปิดหมายเหตุกำกับเมื่อ {{time}}", Nt = "เปิดแบบทดสอบที่ทำแล้วเมื่อ {{time}}", Rt = "เปิดแบบทดสอบเมื่อ {{time}}", Ot = "หยุดชั่วคราว", It = "เปิดเล่น", Ct = "ความเร็วในการเปิดเล่น", Pt = "ความเร็วในการเปิดเล่น: {{speed}}x", Ut = "ภาษาคำบรรยายก่อนหน้า", Lt = "ผลการค้นหาก่อนหน้า", Dt = "คุณภาพ", et = "เมนูคุณภาพ", Mt = "เล่นซ้ำ", ut = "รีเซ็ตความเร็วในการเปิดเล่น", Gt = "ลูกศรขวา", Yt = "ค้นหาในบทอ่าน", Ht = "{{count}} วินาที", rt = "{{count}} วินาที", Vt = "ย้อนกลับ: {{seconds}} วินาที", Bt = "เดินหน้า: {{seconds}} วินาที", it = "ค่าปรับตั้ง", at = "ชอร์ตคัท", Kt = "รายละเอียดมีเดียและเครื่องมือ", mt = "เคาะว่าง", Ft = "เมนูความเร็วในการเปิดเล่น", dt = "เริ่มการเลื่อนอัตโนมัติ", lt = "เปิดปิดคำบรรยาย", ht = "เปิดปิดการเงียบเสียง", Wt = "เปิดเล่น/หยุดชั่วคราว", $t = "{{count}} บรรทัดบทอ่าน", gt = "{{count}} บรรทัดบทอ่าน", Qt = "กำลังโหลดบทอ่าน...", Jt = "เราไม่สามารถโหลดบทอ่านได้", pt = "ตัวเลือกบทอ่าน", xt = "ลองใหม่", Zt = "ไม่มีบทอ่าน", Xt = "ลูกศรขึ้น", ft = "ค่าปรับตั้งวิดีโอ", qt = "ระดับเสียง", vt = "ระดับเสียง: {{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: i,
  CLOSE: a,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: h,
  EDIT_CONFIRM: W,
  EDIT_ERROR: $,
  EDIT_SAVING: g,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: b,
  KEBAB_MENU: j,
  KEYBOARD_SHORTCUTS: k,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: it,
  SHORTCUT: at,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: ht,
  TOGGLE_PLAY_PAUSE: Wt,
  TRANSCRIPT_LINES: $t,
  TRANSCRIPT_LINES_other: gt,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  i as CLEAR_SEARCH,
  a as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  h as EDIT_CLOSE,
  W as EDIT_CONFIRM,
  $ as EDIT_ERROR,
  g as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  b as JUMP_TO_START,
  j as KEBAB_MENU,
  k as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  it as SETTINGS,
  at as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  ht as TOGGLE_MUTED,
  Wt as TOGGLE_PLAY_PAUSE,
  $t as TRANSCRIPT_LINES,
  gt as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  yt as default
};
